var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMalykvet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.721424, 0, 0, 1.721424, -31.197651, -10.567948)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 261.837183 263.05301 C 261.837183 263.05301 319.604129 240.640152 315.315347 180.420204 C 311.028834 120.202526 298.173833 106.886878 280.38333 109.16969 C 262.592826 111.450233 257.387288 124.330195 261.755492 149.940351 C 241.750252 119.219963 227.62904 120.277409 215.747525 126.165975 C 203.86601 132.052272 190.920241 144.364934 201.140704 172.232942 C 182.912245 145.406496 161.727023 148.404105 154.206904 156.75248 C 146.689055 165.103125 131.977851 182.619056 167.490783 227.905419 C 203.005984 273.191782 234.990314 270.536821 261.837183 263.05301 Z M 261.837183 263.05301 ",
    stroke: "#b5bbcd",
    strokeWidth: 7.33,
    strokeOpacity: 1,
    strokeMiterlimit: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.721424, 0, 0, 1.721424, -31.197651, -10.567948)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 267.244679 449.131695 C 267.244679 449.131695 201.161127 449.989452 168.99753 439.28565 C 136.833933 428.579579 111.772922 404.212943 137.737073 376.285936 C 163.701224 348.35666 216.825393 370.901132 227.742499 384.037513 C 238.657337 397.173894 247.03975 400.609458 267.244679 449.131695 Z M 267.244679 449.131695 ",
    stroke: "#b5bbcd",
    strokeWidth: 7.33,
    strokeOpacity: 1,
    strokeMiterlimit: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.721424, 0, 0, 1.721424, -31.197651, -10.567948)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 266.641073 449.079504 C 266.641073 449.079504 335.665505 450.214102 364.239232 430.115825 C 392.81296 410.015279 397.671311 392.848804 375.669177 378.487057 C 353.667044 364.127579 285.110067 382.070119 268.109243 441.71596 ",
    stroke: "#b5bbcd",
    strokeWidth: 7.33,
    strokeOpacity: 1,
    strokeMiterlimit: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.721424, 0, 0, 1.721424, -31.197651, -10.567948)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 261.219962 263.091586 C 261.219962 263.091586 291.277744 340.952271 266.08512 449.099927 ",
    stroke: "#b5bbcd",
    strokeWidth: 7.33,
    strokeOpacity: 1,
    strokeMiterlimit: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalykvet);
export default __webpack_public_path__ + "static/media/malykvet.935e1cd713f44a792d30d130cf2c8c3f.svg";
export { ForwardRef as ReactComponent };